/* eslint-disable max-len */
import React from 'react';
import Modal from 'react-modal';

export default function AdorLoader() {
    return (
        <Modal isOpen>
            <div className="flex justify-center items-center" style={{ height: '80vh' }}>
                <div className="rounded-lg bg-white shadow-s2  px-7 pt-6 pb-3 max-h-[100px] max-w-[100px]">
                    <lottie-player src="https://assets8.lottiefiles.com/packages/lf20_c0b34ayt.json" class="w-full h-[50px]" background="transparent" speed="1" loop autoplay />
                    {/* <p className="text-sm font-normal text-[#555259] text-center">Loading..</p> */}
                </div>
            </div>
        </Modal>
    );
}
